import { MARQUEE_ITEMS } from "../data/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE_ITEMS.map((item, i) => (
      <span key={i} className="flex items-center whitespace-nowrap">
        <span className="px-8 font-serif text-sm sm:text-base italic tracking-wide text-ivory/70">{item}</span>
        <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-gold/15 bg-navy/50 py-4"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
